"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var Modal_styled_1 = require("./Modal.styled");
var ModalCloseIcon_1 = require("../../icons/ModalCloseIcon");
var react_dom_1 = require("react-dom");
var Modal = function (props) {
    var modalBodyRef = (0, react_1.useRef)(null);
    var handleModalClose = function () {
        props.handleClose();
        document.body.style.overflow = 'auto';
    };
    var handleClickOutside = function (event) {
        if (modalBodyRef.current && !modalBodyRef.current.contains(event.target)) {
            props.handleImplicitClose && props.handleImplicitClose();
            handleModalClose();
        }
    };
    var handleCrossClick = function () {
        props.handleImplicitClose && props.handleImplicitClose();
        handleModalClose();
    };
    var renderModal = function () {
        return (react_1.default.createElement(Modal_styled_1.ModalWrapper, { id: "modal-wrapper", "data-testid": "modal-wrapper", onClick: handleClickOutside },
            react_1.default.createElement(Modal_styled_1.ModalContainer, null,
                react_1.default.createElement(Modal_styled_1.ModalBody, { ref: modalBodyRef, width: props === null || props === void 0 ? void 0 : props.width, height: props.height },
                    react_1.default.createElement(Modal_styled_1.ModalIconWrapper, { "data-testid": "modal-content-wrapper" },
                        react_1.default.createElement(Modal_styled_1.ModalIconContainer, { onClick: handleCrossClick, "data-testid": "close-icon" },
                            react_1.default.createElement(ModalCloseIcon_1.ModalCloseIcon, null))),
                    props.children),
                props.footer && react_1.default.createElement(Modal_styled_1.Footer, null, props.footer()))));
    };
    (0, react_1.useEffect)(function () {
        props.isOpen && (document.body.style.overflow = 'hidden');
    });
    return react_1.default.createElement(react_1.default.Fragment, null, props.isOpen ? (0, react_dom_1.createPortal)(renderModal(), document.body) : null);
};
exports.default = Modal;
//# sourceMappingURL=Modal.js.map